import React from "react";
import { Card, Box, Typography } from "@mui/material";
import { Visibility, Share as ShareIcon } from "@mui/icons-material";

interface EngagementStatsCardProps {
  viewCount?: number;
  shareCount?: number;
}

/**
 * Reusable engagement statistics card
 * Displays views and shares with gradient background
 */
export const EngagementStatsCard: React.FC<EngagementStatsCardProps> = ({
  viewCount = 0,
  shareCount = 0,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        background: "linear-gradient(135deg, #1a237e 0%, #3949ab 100%)",
        color: "white",
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 4px 20px rgba(26, 35, 126, 0.15)",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            radial-gradient(circle at 20% 50%, rgba(212, 175, 55, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)
          `,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "grid",
          gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr" },
          gap: 3,
          p: 3,
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Visibility sx={{ fontSize: 32, color: "white", mb: 1 }} />
          <Typography
            variant="h5"
            fontWeight={700}
            sx={{ color: "white", mb: 0.5 }}
          >
            {viewCount.toLocaleString()}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 600 }}
          >
            Views
          </Typography>
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <ShareIcon sx={{ fontSize: 32, color: "white", mb: 1 }} />
          <Typography
            variant="h5"
            fontWeight={700}
            sx={{ color: "white", mb: 0.5 }}
          >
            {shareCount.toLocaleString()}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.9)", fontWeight: 600 }}
          >
            Shares
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};
